import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var MainTitle = /*#__PURE__*/function (_Vue) {
  function MainTitle() {
    var _this;
    _classCallCheck(this, MainTitle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MainTitle, [].concat(args));
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "icon", void 0);
    _defineProperty(_this, "breadcrumbItems", void 0);
    return _this;
  }
  _inherits(MainTitle, _Vue);
  return _createClass(MainTitle, [{
    key: "goTo",
    value: function goTo(url) {
      window.open(url);
    }
  }]);
}(Vue);
export { MainTitle as default };
__decorate([Prop({
  default: 'Your title'
})], MainTitle.prototype, "title", void 0);
__decorate([Prop()], MainTitle.prototype, "icon", void 0);
__decorate([Prop()], MainTitle.prototype, "breadcrumbItems", void 0);